var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circular-graph"},[_c('div',{ref:"chartDom",staticStyle:{"width":"100%","height":"300px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }